export const getCurrentUser = () =>
  localStorage.getItem("cw_user") || "unknown";
